import React from 'react';
import { Icon as FaIcon } from 'react-fa';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';

const CalendarInput = ({ onClick, value }) => {
  return (
    <InputGroup>
      <input
        className="date-picker-input"
        readOnly={true}
        defaultValue={value}
        onClick={onClick}
      />
      <span
        className="input-group-addon"
        style={{ background: 'white', cursor: 'pointer' }}
        onClick={onClick}
      >
        <FaIcon name="calendar" style={{ color: '#4F4F4F' }} />
      </span>
    </InputGroup>
  );
};

CalendarInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
};

export default CalendarInput;
